<!-- 排车调度弹窗 -->
<!-- eslint-disable max-lines -->
<template>
    <div class="carDialog">
        <el-dialog
            class="form-dialog row-dialog"
            :title="title"
            :visible="RwCarVisiable"
            :close-on-click-modal="false"
            :before-close="handleRwCarClose"
            :modal="false"
            width="78%"
            v-dialogDrag
        >
            <el-form
                :label-position="labelPosition"
                :model="AdmittRuleForm"
                :rules="AdmittRules"
                label-width="120px"
                ref="AdmittRuleForm"
                class="rowIndex"
            >
                <el-form-item
                    label="承运商"
                    prop="carrierName"
                    class="label-form"
                    v-model="AdmittRuleForm.carrierName"
                >
                    <otpAdvance
                        ref="carrierName"
                        :disabled="carrierDisabled"
                        :formData="AdmittRuleForm"
                        @clear="clearClick(AdmittRuleForm.carrierName)"
                        :prop="'carrierName'"
                        :mValue="AdmittRuleForm.carrierName"
                        :params="customerOrderNoCode"
                        @getAdvanceValue="getAdvanceValueLists"
                    ></otpAdvance>
                </el-form-item>
                <el-form-item
                    v-model="AdmittRuleForm.procurementChannel"
                    label="采购渠道"
                    prop="procurementChannel"
                    value-key="id"
                    class="label-form"
                >
                    <selects
                        :disabled="!!AdmittRuleForm.carrierName"
                        :filterable="true"
                        :mValue="AdmittRuleForm.procurementChannel"
                        :optionNum="'OTP_TMS_PROCUREMENT_CHANNEL'"
                        :prop="'procurementChannel'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>

                <el-form-item
                    label="是否顺路带回"
                    prop="conveniently"
                    class="label-form"
                    v-show="inOutTypeName === 'IN'"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <selects
                        :disabled="
              inOutTypeName === 'IN' &&
              AdmittRuleForm.procurementChannel === '190'
                ? !isConvenientlyLists
                : isConvenientlyLists
            "
                        :optionNum="'YES_OR_NO'"
                        :mValue="AdmittRuleForm.conveniently"
                        :prop="'conveniently'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    label="计费车型"
                    prop="equipmentName"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        clearable
                        :disabled="true"
                        v-model="AdmittRuleForm.equipmentName"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="预计到车时间"
                    prop="besArriveDate"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-date-picker
                        popper-class="dispatch-center-car-scheduling"
                        v-model="AdmittRuleForm.besArriveDate"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item
                    v-if="AdmittRuleForm.procurementChannel && iconShow"
                    class="label-form"
                    label="车牌司机来源"
                >
                    <el-radio v-model="systemSource" label="SRM" @input="setConfig">已注册运力</el-radio>
                    <el-radio v-model="systemSource" label="LSP" @input="setConfig">专线零担运力</el-radio>
                </el-form-item>
                <el-form-item
                    label="车牌"
                    prop="vehicleCard"
                    class="label-form"
                    v-model="AdmittRuleForm.vehicleCard"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :prop="'vehicleCard'"
                        :mValue="AdmittRuleForm.vehicleCard"
                        @getAdvanceValue="getVehicleCardValue"
                        :params="vehicleCardLists"
                    ></otpAdvance>
                </el-form-item>
                <div
                    class="icon-vehicleCard-box"
                    v-if="AdmittRuleForm.procurementChannel && iconShow"
                >
                    <i
                        class="el-icon-circle-plus-outline"
                        id="icon-vehicleCard"
                        @click="addVehicleCardInfo"
                    ></i>
                </div>
                <el-form-item
                    label="司机"
                    prop="driver"
                    class="label-form"
                    v-model="AdmittRuleForm.driver"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :mValue="AdmittRuleForm.driver"
                        :prop="'driver'"
                        @getAdvanceValue="getDriverValue"
                        :params="driverLists"
                    ></otpAdvance>
                </el-form-item>
                <div class="icon-driver-box" v-if="AdmittRuleForm.procurementChannel && iconShow">
                    <i class="el-icon-circle-plus-outline" id="icon-driver" @click="addDriverInfo"></i>
                </div>
                <el-form-item
                    label="电话"
                    prop="driverContactWay"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        clearable
                        :disabled="true"
                        v-model.trim="AdmittRuleForm.driverContactWay"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="运输成本(元)"
                    prop="transportationCost"
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              !['10', '20', '40', '120', '190', '171'].includes(
                AdmittRuleForm.procurementChannel
              )
          "
                >
                    <el-input
                        clearable
                        @blur="transportationCostBlur(AdmittRuleForm.transportationCost)"
                        v-model.trim="AdmittRuleForm.transportationCost"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="预付方式"
                    prop="payMethod"
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              !['10', '20', '40', '120', '190', '171'].includes(
                AdmittRuleForm.procurementChannel
              )
          "
                >
                    <selects
                        clearable
                        :mValue="AdmittRuleForm.payMethod"
                        :optionNum="'SYS_TMS_PAY_METHOD'"
                        :prop="'payMethod'"
                        @getSelectValue="getPayInAdvanceSelectValue"
                        @clear="clearPayMethodLits(AdmittRuleForm.payMethod)"
                    ></selects>
                </el-form-item>
                <el-form-item
                    label="预付金额(元)"
                    prop="prepaidAmount"
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              !['10', '20', '40', '120', '190', '171'].includes(
                AdmittRuleForm.procurementChannel
              )
          "
                >
                    <el-input
                        @clear="prepaidAmountClear(AdmittRuleForm.prepaidAmount)"
                        @blur="changeBlur(AdmittRuleForm.prepaidAmount)"
                        ref="isPrepaidAmount"
                        clearable
                        v-model.trim="AdmittRuleForm.prepaidAmount"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="信息费用(元)"
                    prop="infoFee"
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              !['10', '20', '40', '120', '190', '171'].includes(
                AdmittRuleForm.procurementChannel
              )
          "
                >
                    <el-input
                        clearable
                        @clear="infoFeeClear(AdmittRuleForm.infoFee)"
                        @blur="changeInfoFeeBlur(AdmittRuleForm.infoFee)"
                        v-model.trim="AdmittRuleForm.infoFee"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="现汇税率(%)"
                    prop="taxRate"
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              !['10', '20', '40', '120', '190', '171'].includes(
                AdmittRuleForm.procurementChannel
              )
          "
                >
                    <otpAdvance
                        :mValue="AdmittRuleForm.taxRate.toString()"
                        :prop="'taxRate'"
                        @getAdvanceValue="getTaxRateValue"
                        :params="taxRateLists"
                    ></otpAdvance>
                </el-form-item>
                <el-form-item
                    label="是否串点计费"
                    prop="dmsFlag"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <selects
                        :disabled="isDmsFlagDisabled"
                        :mValue="
              this.AdmittRuleForm.procurementChannel === '190' ? '1' : '0'
            "
                        :optionNum="'YES_OR_NO'"
                        :prop="'dmsFlag'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    label="备注"
                    prop="remark"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        class="exception-mark"
                        type="textarea"
                        maxlength="50"
                        show-word-limit
                        autosize
                        clearable
                        v-model.trim="AdmittRuleForm.remark"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="装载过低异常类型"
                    prop="exceptionType"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <selects
                        :mValue="AdmittRuleForm.exceptionType"
                        :optionNum="'EXCEPTION_TYPE'"
                        :prop="'exceptionType'"
                        @getSelectValue="getSelectValue"
                    ></selects>
                </el-form-item>
                <el-form-item
                    label="装载过低异常备注"
                    prop="exceptionMark"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <el-input
                        class="exception-mark"
                        type="textarea"
                        maxlength="100"
                        show-word-limit
                        autosize
                        clearable
                        v-model.trim="AdmittRuleForm.exceptionMark"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="设备号"
                    class="label-form"
                    v-if="['10', '190'].includes(AdmittRuleForm.procurementChannel)"
                >
                    <el-input :disabled="true" v-model.trim="AdmittRuleForm.deviceNo" size="medium"></el-input>
                </el-form-item>
                <el-form-item
                    label="班次"
                    prop="vehicleScheduleName"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel"
                    v-model="AdmittRuleForm.vehicleScheduleName"
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :prop="'vehicleScheduleName'"
                        :mValue="AdmittRuleForm.vehicleScheduleName"
                        :params="vehicleScheduleNames"
                        @getAdvanceValue="getBanCiName"
                    ></otpAdvance>
                </el-form-item>
                <el-form-item
                    label="油卡金额(元)"
                    prop="oilcardPayAmount"
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              AdmittRuleForm.procurementChannel === '00'
          "
                >
                    <el-input
                        clearable
                        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                        v-model.trim="AdmittRuleForm.oilcardPayAmount"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="排车计划要求"
                    prop="planRemark"
                    class="label-form"
                    v-if="isPlanArrange"
                >
                    <el-input clearable v-model.trim="AdmittRuleForm.planRemark" size="medium"></el-input>
                </el-form-item>
                <el-form-item
                    label="是否仓配分离"
                    prop="dispatchType"
                    class="label-form"
                    v-if="AdmittRuleForm.procurementChannel && isPlanArrange"
                >
                    <el-switch
                        v-model="AdmittRuleForm.dispatchType"
                        :active-value="'2'"
                        :inactive-value="'1'"
                        @change="getSelectValue"
                        active-text="是"
                        inactive-text="否"
                    ></el-switch>
                </el-form-item>
                <el-form-item
                    label="提货仓"
                    prop="whName"
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              AdmittRuleForm.dispatchType === '2' &&
              isPlanArrange
          "
                >
                    <otpAdvance
                        :formData="AdmittRuleForm"
                        :prop="'whName'"
                        :mValue="AdmittRuleForm.whName"
                        :params="whNames"
                        @getAdvanceValue="getWhName"
                    ></otpAdvance>
                </el-form-item>
                <el-form-item
                    label="在途联系类别"
                    prop="onWayContactCategory"
                    class="label-form"
                    v-if="intranetInformationFlag"
                >
                    <el-select
                        v-model="AdmittRuleForm.onWayContactCategory"
                        :disabled="informationFlag"
                        placeholder="请选择在途联系类别"
                        @change="onWayContactCategoryChange"
                    >
                        <el-option
                            v-for="item in onWayContactCategoryList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="在途联系人"
                    prop="onWayContactName"
                    class="label-form"
                    v-if="intranetInformationFlag"
                >
                <otpAdvance
                    :formData="AdmittRuleForm"
                    v-if="onWayContactFlag"
                    :disableSearch="true"
                    :prop="'onWayContactName'"
                    :mValue="AdmittRuleForm.onWayContactName"
                    :params="carSchedulingDialog.onWayContactName"
                    @getAdvanceValue="getOnWayContactValue"
                >
                </otpAdvance>
                    <el-input
                        v-else
                        clearable
                        :disabled="informationFlag"
                        v-model.trim="AdmittRuleForm.onWayContactName"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="在途联系人电话"
                    prop="onWayContactPhone"
                    class="label-form"
                    v-if="intranetInformationFlag"
                >
                    <el-input
                        clearable
                        :disabled="informationFlag || onWayContactFlag"
                        v-model.trim="AdmittRuleForm.onWayContactPhone"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="下游会计主体"
                    prop="transUnitName"
                    v-model="AdmittRuleForm.transUnitName"
                    class="label-form"
                >
                    <el-input
                        :disabled="true"
                        v-model.trim="AdmittRuleForm.transUnitName"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    class="label-form"
                    v-if="
            AdmittRuleForm.procurementChannel &&
              (this.siteType === '20' || this.siteType === '40')
          "
                >
                    <el-checkbox
                        disabled
                        v-model="AdmittRuleForm.forceChuanDian"
                        :true-label="1"
                        :false-label="0"
                    >直控线路串点计费模式</el-checkbox>
                </el-form-item>
                <el-form-item
                    class="label-form"
                    label="发运类型"
                    prop="shippingType"
                    v-if="AdmittRuleForm.procurementChannel"
                >
                    <selects
                        :optionNum="'TMS_SHIPPING_TYPE'"
                        :mValue="AdmittRuleForm.shippingType"
                        @getSelectValue="getSelectValue($event, 'shippingType')"
                        placeholder="请选择发运类型"
                        :prop="'shippingType'"
                    ></selects>
                </el-form-item>
                <el-form-item
                    label="是否直通宝转运"
                    prop="ztbTransportFlag"
                    class="label-form"
                    v-if="AdmittRuleForm.shippingType === '0'"
                >
                    <el-select v-model="AdmittRuleForm.ztbTransportFlag" placeholder="请选择是否直通宝转运">
                        <el-option
                            v-for="item in ztbTransportFlagList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item
                    v-if="AdmittRuleForm.procurementChannel"
                    class="label-form"
                    key="actualEquipmentName"
                    label="实际运作车型">
                    <el-input
                        v-model="AdmittRuleForm.equipmentName"
                        size="medium"
                        clearable
                        disabled/>
                </el-form-item>

                <el-form-item
                    v-if="AdmittRuleForm.procurementChannel"
                    key="scheduleVehicleRequirement"
                    style="width: 100%"
                    label="车型排车考核要求">
                    <span style="color: #FF4949">{{ scheduleVehicleRequirement }}</span>
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button @click="handleRwCarClose">取 消</el-button>
                <el-button
                    type="primary"
                    :loading="saveLoading"
                    :disabled="isButtonDisabled"
                    @click="AdmittOk('AdmittRuleForm')"
                >保 存</el-button>
            </div>
        </el-dialog>

        <vehicleCard-manage-dialog
            ref="vehicleCardDialog"
            :supplierCode="AdmittRuleForm.supplierCode"
            :dialogVisible.sync="vehicleCardDialogVisible"
            v-if="vehicleCardDialogVisible"
            @handleVehicleCardDialogClose="handleVehicleCardDialogClose"
        ></vehicleCard-manage-dialog>

        <driver-manage-dialog
            ref="driverDialog"
            :supplierCode="AdmittRuleForm.supplierCode"
            :dialogVisible.sync="driverDialogVisible"
            v-if="driverDialogVisible"
            @handleDriverDialogClose="handleDriverDialogClose"
        ></driver-manage-dialog>
    </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */
import {
    getLicensePlate,
    getDriverName,
    getWhitelistList,
    getSearchBySupplier,
    isLingDanApi,
} from "../../../../api/carSchedulingDialog";
import { dictWithUrl } from '@/components/lots/api.js';
import carSchedulingDialog from "./carSchedulingDialog.js";
import driverManageDialog from "../../../../components/dialog/carSchedulingDialog/driverManageDialog";
import vehicleCardManageDialog from "../../../../components/dialog/carSchedulingDialog/vehicleCardManageDialog";
import otpAdvance from "@/components/lots/otpAdvance";
import advanceDialog from "@/components/lots/otpAdvanceDialog";
import selects from "@/components/lots/otpSelect";
export default {
    components: {
        selects,
        otpAdvance,
        advanceDialog,
        driverManageDialog,
        vehicleCardManageDialog,
    },
    props: {
        isPlanArrange: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "排车调度",
        },
        labelPosition: {
            type: String,
            default: "right",
        },
        carrierDisabled: {
            type: Boolean,
            default: false,
        },
        RwCarVisiable: {
            type: Boolean,
            default: false,
        },
        dataLists: {
            type: Object,
            default () {
                return {};
            },
        },
        taskDataList: {
            type: Array,
            default () {
                return [];
            },
        },
        isConveniently: {
            type: Boolean,
            default: true,
        },
        inOutType: {
            type: String,
            default () {
                return "";
            },
        },
    },
    data () {
        return {
            carSchedulingDialog,
            vehicleCardDialogVisible: false,
            driverDialogVisible: false,
            siteType: "",
            iconShow: false,
            systemSource: "SRM", // 司机车牌系统来源
            isDmsFlagDisabled: true,
            isConvenientlyLists: true,
            driverOptions: [],
            LicensePlateOptions: [],
            businessOptions: [],
            onWayContactCategoryList: [
                {
                    value: "1",
                    label: "司机",
                },
                {
                    value: "2",
                    label: "供应商",
                },
            ],
            ztbTransportFlagList: [
                { value: 1, label: '是' },
                { value: 0, label: '否' }
            ],
            pickerOptions: {
                disabledDate (time) {
                    const today = new Date(); // 当前日期
                    const day = time.getTime(); // 当前时间的毫秒数
                    return day < today.setHours(0, 0, 0, 0); // 将当前日期小时、分钟、秒和毫秒设置为 0,与时间戳比较
                }
            },
            AdmittRuleForm: {
                supplierCode: "",
                routeNoList: [],
                carrierName: "",
                dmsFlag: "",
                procurementChannel: "",
                conveniently: "",
                vehicleCard: "",
                equipmentName: "",
                driver: "",
                driverContactWay: "",
                besArriveDate: "",
                payMethod: "",
                transportationCost: "",
                prepaidAmount: "",
                taxRate: "",
                remark: "",
                driverIdentity: "",
                infoFee: "",
                equipmentType: "",
                exceptionType: "",
                exceptionMark: "",
                deviceNo: "",
                vehicleScheduleName: "",
                companyCode: "",
                oilcardPayAmount: "",
                planRemark: "",
                dispatchType: "",
                whName: "",
                onWayContactName: "", // 在途联系类别
                onWayContactCategory: "", // 在途联系人
                onWayContactPhone: "", // 在途联系人电话
                transUnitName: "",
                transUnitCode: "",
                paymentTerms: '',
                transportContractNo: '',
                forceChuanDian: 0,
                shippingType: '', // 发运类型
                ztbTransportFlag: 1,// 是否直通宝转运
                supplierStatus: '30',
                businessTypeStatus: '5'
            },
            prepaidAmount: "",
            taxRate: "",
            isButtonDisabled: false,
            saveLoading: false,
            intranetInformationFlag: false,
            informationFlag: false,
            dictData: {} // 字典数据
        };
    },
    created () {
        this.setData();
        this.setConfig();
        this.IsLspAndLsrm();
        this.customerOrderNoCode = carSchedulingDialog.customerOrderNoCode;
        this.vehicleScheduleNames = carSchedulingDialog.vehicleScheduleNames;
        this.taxRateLists = carSchedulingDialog.taxRateLists;
        this.AdmittRules = carSchedulingDialog.AdmittRules;
        this.whNames = carSchedulingDialog.whNames;
        this.getDictData();
    },
    watch: {
        "AdmittRuleForm.carrierName": {
            deep: true,
            handler: function (newVal, oldVal) {
                if (
                    newVal !== oldVal &&
                    this.dataLists.carrierName !== this.AdmittRuleForm.carrierName
                ) {
                    this.AdmittRuleForm.vehicleCard = "";
                    this.AdmittRuleForm.driver = "";
                    this.AdmittRuleForm.equipmentName = "";
                    this.AdmittRuleForm.besArriveDate = "";
                    this.AdmittRuleForm.driverContactWay = "";
                    this.AdmittRuleForm.transportationCost = "";
                    this.AdmittRuleForm.payMethod = "";
                    this.AdmittRuleForm.prepaidAmount = "";
                    this.AdmittRuleForm.infoFee = "";
                    this.AdmittRuleForm.taxRate = "";
                    this.AdmittRuleForm.remark = "";
                    this.AdmittRuleForm.forceChuanDian = 0;
                }
            },
        },
    },
    computed: {
        show: {
            set (val) {
                this.$emit("update:RwCarVisiable", val);
            },
            get () {
                return this.RwCarVisiable;
            },
        },
        inOutTypeName: {
            set (val) { },
            get () {
                return this.inOutType;
            },
        },
        siteCodeList () {
            return [...new Set(this.taskDataList.map(i => i.siteCode))];
        },
        professionalCompanyList () {
            return [...new Set(this.taskDataList.map(i => i.professionalCompany))];
        },
        // 在途联系人是否可选
        onWayContactFlag () {
            if (!this.informationFlag && this.AdmittRuleForm.onWayContactCategory === '2') {
                return true;
            }
            return false;
        },

        // 车型排车考核要求：内容做成参数配置，上线初始化：“请按真实运作车型排车，如果计费车型错误，发车之后OMS改单修改车型，不允许SRM乱维护车牌号对应的运作车型”
        scheduleVehicleRequirement() {
            const dictObj = this.dictData.SCHEDULE_VEHICLE_REQUIREMENT;
            return dictObj ? dictObj.value : '';
        }
    },
    methods: {

        // 获取数据字典
        async getDictData () {
            const res = await dictWithUrl([
                'SCHEDULE_VEHICLE_REQUIREMENT' // 车型排车考核要求
            ].join(','));
            if (res && +res.code === 0) {
                this.dictData = res.data || {};
            }
        },
        // 信息费用
        changeInfoFeeBlur (infoFee) {
            if (infoFee === undefined || infoFee === "") {
                this.isButtonDisabled = false;
            } else {
                const reg = /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|0.0|0.00|0)$/;
                if (!reg.test(infoFee)) {
                    this.isButtonDisabled = true;
                    return this.$message.warning(
                        "请输入数字，可为0，最多支持2位小数；最高支持十万"
                    );
                } else {
                    this.isButtonDisabled = false;
                }
            }
        },
        // 预付金额
        changeBlur (prepaidAmount) {
            const reg = /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|0.0|0.00|0)$/;
            if (
                Number(prepaidAmount) > Number(this.AdmittRuleForm.transportationCost)
            ) {
                this.$message.warning("预付金额不可大于运输成本");
                this.isButtonDisabled = true;
                return false;
            } else {
                this.isButtonDisabled = false;
            }
            if (!reg.test(prepaidAmount) && prepaidAmount) {
                this.isButtonDisabled = true;
                return this.$message.warning(
                    "请输入数字，可为0，最多支持2位小数；最高支持十万"
                );
            }
        },
        prepaidAmountClear (prepaidAmount) {
            if (prepaidAmount === "" && this.AdmittRuleForm.payMethod) {
                this.$message.warning("请填写预付金额");
                this.isButtonDisabled = true;
                return false;
            }
            if (!prepaidAmount) {
                this.isButtonDisabled = false;
            }
        },
        infoFeeClear (infoFee) {
            if (!infoFee) {
                this.isButtonDisabled = false;
            }
        },
        // 运输成本
        transportationCostBlur (transportationCost) {
            if (
                Number(this.AdmittRuleForm.transportationCost) <
                Number(this.AdmittRuleForm.prepaidAmount)
            ) {
                this.$message.warning("预付金额不可大于运输成本");
                this.isButtonDisabled = true;
                return false;
            } else {
                this.isButtonDisabled = false;
            }
        },
        // 打开车牌新增 弹窗
        addVehicleCardInfo () {
            this.vehicleCardDialogVisible = true;
        },
        // 关闭
        handleDriverDialogClose () {
            this.driverDialogVisible = false;
        },
        // 打开司机新增 弹窗
        addDriverInfo () {
            this.driverDialogVisible = true;
        },
        // 关闭
        handleVehicleCardDialogClose () {
            this.vehicleCardDialogVisible = false;
        },
        // 车牌基础数据
        getVehicleCardValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        // 司机基础数据
        getDriverValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            this.AdmittRuleForm.onWayContactCategory = data.onWayContactCategory
                ? data.onWayContactCategory
                : "";
            this.AdmittRuleForm.onWayContactName = data.onWayContactName
                ? data.onWayContactName
                : "";
            this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone
                ? data.onWayContactPhone
                : "";
            this.informationFlag = false;
            if (
                !data.onWayContactCategory &&
                !data.onWayContactName &&
                !data.onWayContactPhone
            ) {
                this.setInformationEntry(this.AdmittRuleForm.propertyNature);
            } else {
                // 是否手填/新在途联系人
                this.AdmittRuleForm.newOnWayContact = false;
                this.intranetInformationFlag = true;
                this.informationFlag = true;
            }
        },
        // 在途联系人基础数据
        getOnWayContactValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm };
            this.AdmittRuleForm.onWayContactName = data.contacts ? data.contacts : '';
            this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone ? data.onWayContactPhone : '';
        },
        // 现汇税率基础数据
        getTaxRateValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            this.taxRate = data.taxRate.toString();
        },
        // 承运商基础数据
        getAdvanceValueLists (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            this.siteType = data.transType;
            this.AdmittRuleForm.procurementChannel = data.transType;
            this.AdmittRuleForm.dmsFlag =
                this.AdmittRuleForm.procurementChannel === "190" ? "1" : "0";
            this.getLicensePlateLists();
            this.getDriverNameLists();
            // 获取承运商主体类型属性
            this.getCarrierType(data.carrierCode);
            this.intranetInformationFlag = false;
            // 匹配零担线路配置
            if (this.whiteListCheck()) {
                this.isLingDan();
            }
        },
        // 获取承运商主体类型属性
        getCarrierType (carrierCode) {
            getSearchBySupplier({
                pageNo: 1,
                pageSize: 10,
                supplierCode: carrierCode,
                professionalCompanyList: this.professionalCompanyList,
                siteCodeList: this.siteCodeList,
                supplierStatus: '30',
                businessTypeStatus: '5'
            }).then((res) => {
                if (res.data.list[0].propertyNature === 1) {
                    this.AdmittRuleForm.propertyNature = res.data.list[0].propertyNature;
                }
            });
        },
        // 班次基础数据
        getVehicleScheduleName (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        // 预付方式
        clearPayMethodLits (payMethod) {
            if (payMethod === "") {
                this.AdmittRuleForm.prepaidAmount = "";
            }
        },
        // 预付方式数据字典
        getPayInAdvanceSelectValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            const prepaidAmountLists = this.AdmittRuleForm.prepaidAmount;
            if (data.payMethod && prepaidAmountLists === undefined) {
                this.isButtonDisabled = true;
                this.$message.warning("请填写预付金额");
            } else {
                this.isButtonDisabled = false;
            }
        },
        // 数据字典
        getSelectValue (data, prop) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
            if (prop === 'shippingType') {
                if (+data[prop] === 0) {
                    this.AdmittRuleForm.ztbTransportFlag = 1;
                }
            }
        },
        getSelectTaxRateValue (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        getBanCiName (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        getWhName (data) {
            this.AdmittRuleForm = { ...this.AdmittRuleForm, ...data };
        },
        // 车牌基础数据接口请求
        getLicensePlateLists (data) {
            const params = {
                pageSize: 10,
                pageNo: 1,
                supplierCode: this.AdmittRuleForm.supplierCode,
                routeNoList: this.AdmittRuleForm.routeNoList,
            };
            getLicensePlate(params).then((res) => {
                if (res.data.list.length === 1) {
                    const data = res.data.list[0];
                    this.AdmittRuleForm.vehicleCard = data.licensePlateNo;
                    this.AdmittRuleForm.cargoVolumeStr = data.maxVolume;
                    this.AdmittRuleForm.equipmentName = data.carTypeNameCn;
                    this.AdmittRuleForm.equipmentType = data.carType;
                    this.AdmittRuleForm.deviceNo = data.deviceNo;
                }
            });
        },
        // 基础数据司机查询接口
        getDriverNameLists (data) {
            const params = {
                pageSize: 10,
                pageNo: 1,
                supplierCode: this.AdmittRuleForm.supplierCode,
                routeNoList: this.AdmittRuleForm.routeNoList,
            };
            getDriverName(params).then((res) => {
                if (res.data.list.length === 1) {
                    const data = res.data.list[0];
                    this.AdmittRuleForm.driver = data.driverName;
                    this.AdmittRuleForm.driverContactWay = data.driverPhone;
                    this.AdmittRuleForm.driverIdentity = data.driverIdCard;
                    if (
                        !data.onWayContactCategory &&
                        !data.onWayContactName &&
                        !data.onWayContactPhone
                    ) {
                        this.AdmittRuleForm.onWayContactCategory = data.onWayContactCategory
                            ? data.onWayContactCategory
                            : "";
                        this.AdmittRuleForm.onWayContactName = data.onWayContactName
                            ? data.onWayContactName
                            : "";
                        this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone
                            ? data.onWayContactPhone
                            : "";
                        this.informationFlag = false;
                        this.setInformationEntry(this.AdmittRuleForm.propertyNature);
                    } else {
                        this.AdmittRuleForm.onWayContactCategory =
                            data.onWayContactCategory;
                        this.AdmittRuleForm.onWayContactName = data.onWayContactName;
                        this.AdmittRuleForm.onWayContactPhone = data.onWayContactPhone;
                        // 是否手填/新在途联系人
                        this.AdmittRuleForm.newOnWayContact = false;
                        this.informationFlag = true;
                    }
                }
            });
        },
        // 司机在途信息录入->当前运输单的服务平台是否存在于白名单->如果存在于白名单并且承运商主体是法人->将司机在途信息带入
        setInformationEntry (propertyNature) {
            getWhitelistList().then((res) => {
                let flag = null;
                if (this.dataLists.siteCode) {
                    flag = res.data.includes(this.dataLists.siteCode);
                    if (flag) {
                        if (propertyNature === 1) {
                            this.intranetInformationFlag = flag;
                            // 是否手填/新在途联系人
                            this.AdmittRuleForm.newOnWayContact = true;
                        } else {
                            this.intranetInformationFlag = false;
                        }
                    }
                }
                if (this.taskDataList.length) {
                    const list = this.taskDataList.map((item) => item.siteCode);
                    for (let i = 0; i <= list.length; i++) {
                        flag = res.data.includes(list[i]);
                        if (flag) {
                            if (propertyNature === 1) {
                                this.intranetInformationFlag = flag;
                                // 是否手填/新在途联系人
                                this.AdmittRuleForm.newOnWayContact = true;
                                return;
                            } else {
                                this.intranetInformationFlag = false;
                            }
                        } else {
                            this.intranetInformationFlag = flag;
                        }
                    }
                }
            });
        },
        // 白名单
        async isLingDan () {
            const params = {
                taskNos: this.taskDataList.map(v => v.taskNo),
                carrierCode: this.AdmittRuleForm.carrierCode,
                carrierName: this.AdmittRuleForm.carrierName,
                procurementChannel: this.AdmittRuleForm.procurementChannel
            };
            this.AdmittRuleForm.shippingType = '';// 清空发运类型
            await isLingDanApi(params).then(res => {
                if (res && +res.code === 0) {
                    if (res.data === 2) return false; // 返回2时，默认为空
                    this.AdmittRuleForm.shippingType = res.data + '';
                }
            });
        },
        // 判断是否为零担干线公司或零担干线-网络或者城配
        whiteListCheck () {
            const updateShippingTypeTaskNos = [];
            this.taskDataList.forEach(item => {
                if ([3, 4, 5].includes(+item.professionalCompany)) {
                    updateShippingTypeTaskNos.push(item.taskNo);
                }
            });
            if (updateShippingTypeTaskNos.length) {
                this.AdmittRuleForm.updateShippingTypeTaskNos = JSON.parse(JSON.stringify(updateShippingTypeTaskNos));
                return true;
            } else {
                return false;
            }
        },
        handleRwCarClose () {
            this.$emit("update:RwCarVisiable", false);
        },
        AdmittOk (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const reg = /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|0.0|0.00|0)$/;
                    if (
                        this.AdmittRuleForm.payMethod &&
                        !this.AdmittRuleForm.prepaidAmount
                    ) {
                        this.$message.warning("请填写预付金额");
                        this.isButtonDisabled = true;
                    } else if (
                        Number(this.AdmittRuleForm.prepaidAmount) &&
                        !this.AdmittRuleForm.payMethod
                    ) {
                        this.$message.warning("请填写预付方式");
                        this.isButtonDisabled = true;
                    } else if (
                        Number(this.AdmittRuleForm.prepaidAmount) >
                        Number(this.AdmittRuleForm.transportationCost)
                    ) {
                        this.$message.warning("预付金额不可大于运输成本");
                        this.isButtonDisabled = true;
                    } else if (
                        this.AdmittRuleForm.infoFee &&
                        !reg.test(this.AdmittRuleForm.infoFee)
                    ) {
                        this.isButtonDisabled = true;
                        return this.$message.warning("信息费用不能大于十万");
                    } else {
                        this.isButtonDisabled = false;
                        this.AdmittRuleForm["procurementChannel"] = this.siteType;
                        if (this.AdmittRuleForm.shippingType !== '0') {
                            delete this.AdmittRuleForm.ztbTransportFlag;
                        }
                        const data = Object.assign(
                            {
                                ntpManagerReverseProcessFlag: false,
                                carSourceFlag: this.systemSource,
                                operateSystem: "LSP",
                            },
                            this.AdmittRuleForm
                        );
                        delete data.supplierCode;
                        delete data.routeNoList;
                        this.$emit("AdmittOk", { state: true, data });
                    }
                } else {
                    this.$emit("AdmittOk", { state: false, form: valid, data: {} });
                    return false;
                }
            });
        },
        // 赋值
        setData () {
            this.AdmittRuleForm.siteCode = this.dataLists.siteCode;
            this.AdmittRuleForm.standardCost = this.dataLists.standardCost;
            this.AdmittRuleForm.iflowStatus = this.dataLists.iflowStatus;
            this.AdmittRuleForm.iflowLink = this.dataLists.iflowLink;
            this.AdmittRuleForm.driverIdentity = this.dataLists.driverIdentity;
            this.AdmittRuleForm.carrierName = this.dataLists.carrierName; // 承运商
            this.AdmittRuleForm.carrierCode = this.dataLists.carrierCode; // 承运商编码
            this.siteType = this.dataLists.procurementChannel; // 采购渠道
            this.AdmittRuleForm.procurementChannel = this.dataLists.procurementChannel;
            this.AdmittRuleForm.vehicleCard = this.dataLists.vehicleCard; // 车牌
            this.AdmittRuleForm.deviceNo = this.dataLists.deviceNo; // 设备号
            this.AdmittRuleForm.vehicleScheduleName = this.dataLists.vehicleScheduleName; // 班次
            this.AdmittRuleForm.companyCode = this.dataLists.companyCode; // 分公司
            this.AdmittRuleForm.driverNo = this.dataLists.driverNo; // 司机编码
            if (!this.AdmittRuleForm.conveniently) {
                this.AdmittRuleForm.conveniently = 0;
            }
            this.AdmittRuleForm.conveniently = this.dataLists.conveniently
                ? this.dataLists.conveniently
                : "0";
            this.AdmittRuleForm.equipmentName = this.dataLists.equipmentName;
            this.AdmittRuleForm.besArriveDate = this.dataLists.besArriveDate;
            this.AdmittRuleForm.driver = this.dataLists.driver;
            this.AdmittRuleForm.driverContactWay = this.dataLists.driverContactWay;
            this.AdmittRuleForm.transportationCost = this.dataLists.transportationCost;
            this.AdmittRuleForm.payMethod = this.dataLists.payMethod;
            this.AdmittRuleForm.prepaidAmount = this.dataLists.prepaidAmount;
            this.AdmittRuleForm.infoFee = this.dataLists.infoFee;
            if (
                this.AdmittRuleForm.taxRate === "" &&
                this.dataLists.taxRate === undefined
            ) {
                this.dataLists.taxRate = "";
            }
            this.AdmittRuleForm.taxRate = String(this.dataLists.taxRate)
                ? String(this.dataLists.taxRate)
                : "";
            this.AdmittRuleForm.dmsFlag =
                this.AdmittRuleForm.procurementChannel === "190" ? "1" : "0";
            this.AdmittRuleForm.remark = this.dataLists.remark;
            this.AdmittRuleForm.supplierCode = this.dataLists.carrierCode;
            this.AdmittRuleForm.exceptionType = this.dataLists.exceptionType;
            this.AdmittRuleForm.exceptionMark = this.dataLists.exceptionMark;
            if (this.AdmittRuleForm.conveniently === 1) {
                this.AdmittRuleForm.conveniently = "1";
            } else if (this.AdmittRuleForm.conveniently === 0) {
                this.AdmittRuleForm.conveniently = "0";
            }
            if (this.AdmittRuleForm.payMethod === "网银转账") {
                this.AdmittRuleForm.payMethod = "0";
            } else if (this.AdmittRuleForm.payMethod === "油卡支付") {
                this.AdmittRuleForm.payMethod = "1";
            }
            this.AdmittRuleForm.oilcardPayAmount = this.dataLists.oilcardPayAmount;
            this.AdmittRuleForm.planRemark = this.dataLists.planRemark;
            this.AdmittRuleForm.dispatchType = this.dataLists.dispatchType;
            this.AdmittRuleForm.whName = this.dataLists.wtWhCode;
            this.AdmittRuleForm.onWayContactCategory = this.dataLists.onWayContactCategory;
            this.AdmittRuleForm.onWayContactName = this.dataLists.onWayContactName;
            this.AdmittRuleForm.onWayContactPhone = this.dataLists.onWayContactPhone;
            const {
                onWayContactCategory,
                onWayContactName,
                onWayContactPhone,
            } = this.dataLists;
            // 获取承运商主体类型属性
            if (onWayContactCategory && onWayContactName && onWayContactPhone) {
                // 获取承运商主体类型属性
                this.getCarrierType(this.dataLists.carrierCode);
                this.AdmittRuleForm.newOnWayContact = false;
                this.intranetInformationFlag = true;
                this.informationFlag = true;
            }
            this.AdmittRuleForm.transUnitName = this.dataLists.transUnitName;
            this.AdmittRuleForm.transUnitCode = this.dataLists.transUnitCode;
            this.AdmittRuleForm.paymentTerms = this.dataLists.paymentTerms;
            this.AdmittRuleForm.transportContractNo = this.dataLists.transportContractNo;
            this.AdmittRuleForm.forceChuanDian = this.dataLists.forceChuanDian;
            this.AdmittRuleForm.shippingType = this.dataLists.shippingType;
            this.AdmittRuleForm.siteCodeList = this.siteCodeList;
            this.AdmittRuleForm.ztbTransportFlag = this.dataLists.ztbTransportFlag || 1;
            this.AdmittRuleForm.siteCode = this.dataLists.siteCode;
        },
        clearClick (carrierName) {
            if (!carrierName) {
                this.AdmittRuleForm.driverContactWay = "";
                this.AdmittRuleForm.equipmentName = "";
            }
        },
        IsLspAndLsrm () {
            this.iconShow = this.taskDataList.every((v) => {
                return +v.distributionNum >= 2 && +v.professionalCompany === 3;
            });
        },
        setConfig () {
            if (this.systemSource === "SRM") {
                this.vehicleCardLists = carSchedulingDialog.vehicleCardLists;
                this.driverLists = carSchedulingDialog.driverLists;
            } else if (this.systemSource === "LSP") {
                this.vehicleCardLists = carSchedulingDialog.LSPVehicleCardLists;
                this.driverLists = carSchedulingDialog.LSPDriverLists;
            }
        },
        // 可编辑状态下在途联系类别改变
        onWayContactCategoryChange (val) {
            this.AdmittRuleForm.onWayContactName = '';
            this.AdmittRuleForm.onWayContactPhone = '';
            if (val === '1') {
                this.AdmittRuleForm.onWayContactName = this.AdmittRuleForm.driver;
                this.AdmittRuleForm.onWayContactPhone = this.AdmittRuleForm.driverContactWay;
            }
        }
    }
};
</script>

<style lang="less">
@import '../../../../components/dialog/carSchedulingDialog/carSchedulingDialog.less';
.icon-vehicleCard-box {
    position: absolute;
    display: inline-block;
    font-size: 20px;
    left: 50.5%;
    top: 128px;
}
#icon-vehicleCard {
    z-index: 999;
    cursor: pointer;
}
.icon-driver-box {
    position: absolute;
    display: inline-block;
    font-size: 20px;
    left: 75%;
    top: 128px;
}
#icon-driver {
    z-index: 999;
    cursor: pointer;
}
.dispatch-center-car-scheduling {
    .el-picker-panel__footer {
        .el-button--text {
            display: none;
        }
    }
}
</style>
